//A wrapper on a logger implementation, for now just use console

const exportConsole : Console = console;
export default exportConsole;
